<template>
  <div class="culture">
    <div class="culture-content">
      <div class="company-box">
        <div class="culture-text">
          <h2>CORPORATE</h2>
          <h2>CULTURE</h2>
          <span></span>
        </div>
        <h4>企业文化</h4>
      </div>
      <div class="content-box">
        <div class="item" v-for="item in contentList" :key="item.id">
          <img :src="item.img" style="width:55px;height:55px;" />
          <h3>{{item.title}}</h3>
          <p style="white-space: pre-wrap">{{item.desc}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Culture",
  props: {
    cultureInfo: Object,
  },
  data() {
    return {
      contentList: [
        {
          id: 0,
          img: require('../../static/images/about/cu1.png'),
          title: "企业使命",
          desc: "为客户提供专业的数字化解决方案"+'\n'+"实现客户的商业成功",
        },{
          id: 1,
          img: require('../../static/images/about/cu2.png'),
          title: "企业愿景",
          desc: "成为客户的商业护航者，成为员工的价值领航者",
        },{
          id: 2,
          img: require('../../static/images/about/cu3.png'),
          title: "行为标准",
          desc: "细节决定成败，协作创造价值，效率成就品牌",
        },{
          id: 3,
          img: require('../../static/images/about/cu4.png'),
          title: "核心价值观",
          desc: "客户为本，需求为先，体验为重，商业为根",
        },{
          id: 4,
          img: require('../../static/images/about/cu5.png'),
          title: "企业司训",
          desc: "凡事有交代、事事有回应、件件有着落",
        },{
          id: 5,
          img: require('../../static/images/about/cu6.png'),
          title: "企业精神",
          desc: "匠心研发，倾力服务",
        }
      ],
    };
  },
  mounted() {},
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';

.culture {
  position: relative;
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
  padding-top: 80px;
  padding-bottom: 80px;

  .culture-content {
    display: flex;
    width:1440px;
    overflow:hidden;
    margin: 0 auto;
    z-index: 1;

    .company-box {
      box-sizing: border-box;
      padding: 100px 0 59px 39px;
      min-width: 358px;
      height: 463px;
      background: #EEF0F2;
    }

    h4 {
      margin-top: 116px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #000000;
      line-height: 28px;
    }

    .culture-text {
      position: relative;

      span {
        position: absolute;
        width: 48px;
        bottom: -20px;
        height: 6px;
        background: #FFC000;
      }

      h2 {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #000000;
        line-height: 60px;
        letter-spacing: 2px;
      }
    }

    .content-box {
      display: flex;
      flex-wrap: wrap;

      .item {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 348px;
        height: 232px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        padding-top: 25px;
      }

      h3 {
        margin: 32px 0 23px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        text-align: center;
      }
    }
  }
  // @media (max-width:1810px) {
  //   .culture-content{
  //     width:82%;
  //     justify-content: center;
  //   }
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/AboutCulture.vue